import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EMPTY_WELFARE_PERMISSIONS } from '~/config/welfarePermissions';
import { WelfareAdminPermissions } from '~/types';

export type WelfareRolesState = {
    // `isLoaded` becomes true only once /me resolves (or fails) THIS session.
    // The whole store is persisted to localStorage, so a refresh replays a stale
    // `isLoaded: true`; the fetch hook clears this slice before refetching so the
    // route guard always waits for a fresh /me rather than trusting stale data.
    isLoaded: boolean;
    isSuperAdmin: boolean;
    permissions: WelfareAdminPermissions;
};

const initialState: WelfareRolesState = {
    isLoaded: false,
    isSuperAdmin: false,
    permissions: EMPTY_WELFARE_PERMISSIONS,
};

export const welfareRolesSlice = createSlice({
    name: 'welfareRoles',
    initialState,
    reducers: {
        setWelfareRoles: (
            state,
            action: PayloadAction<{
                is_super_admin: boolean;
                permissions?: WelfareAdminPermissions;
            }>
        ) => {
            state.isLoaded = true;
            state.isSuperAdmin = !!action.payload.is_super_admin;
            state.permissions = {
                ...EMPTY_WELFARE_PERMISSIONS,
                ...(action.payload.permissions || {}),
            };
        },
        clearWelfareRoles: () => ({ ...initialState }),
    },
});

export const { setWelfareRoles, clearWelfareRoles } =
    welfareRolesSlice.actions;

export default welfareRolesSlice.reducer;
